import React, { useEffect, useState } from "react";
import Select from "react-select";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";

const { forwardRef, useRef, useImperativeHandle } = React;

const RolesSelect = forwardRef(({ oldRoles, onChange, label }, ref) => {
  const { utils } = useSelector(utilsState);

  const [rolesOption, setRolesOption] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [roles, setRoles] = useState([]);

  useImperativeHandle(ref, () => ({
    afterSubmit() {
      setSelectedRoles([]);
    },
  }));
  useEffect(() => {
    if (utils?.ROLES_VALUES?.length) {
      setRoles(utils.ROLES_VALUES);
    }
  }, [utils]);

  useEffect(() => {
    if (utils?.ROLES) {
      let rolesArray = Object.values(utils.ROLES);
      let newRoles = [];
      rolesArray?.forEach((item) =>
        newRoles.push({
          value: item.value,
          label: item.name,
        })
      );
      setRolesOption(newRoles);
    }
  }, [roles]);
  useEffect(() => {
    console.log("oldRoles", oldRoles);

    if (oldRoles?.length > 0 && utils.ROLES) {
      let oldSelectedRoles = [];
      for (let i = 0; i < oldRoles?.length; i++) {
        let isExist = oldRoles.filter((item) => {
          return item === oldRoles[i];
        });
        const rolesConst = utils.ROLES[isExist];
        oldSelectedRoles.push({
          value: rolesConst.value,
          label: rolesConst.name,
        });
      }  
      setSelectedRoles(oldSelectedRoles);
    }
  }, [oldRoles, roles]);

  function handleRoles(data) {
    setSelectedRoles(data);
    const newData = data.map((item) => {
      return item.value;
    });
    onChange(newData || []);
  }

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
      </label>
      <Select
        className=""
        options={rolesOption}
        placeholder="انتخاب نقش"
        value={selectedRoles}
        onChange={handleRoles}
        isSearchable={true}
        isMulti
      />
    </div>
  );
});

export default RolesSelect;
